import React, {useContext} from 'react';
import './PrivacyPolicyRegister.css';
import { LocaleContext } from '../common/App';
import { Footer } from './WebsiteCommon';
import { SuspenseComp } from './Imprint';

import PrivacyPolicyContactDe from './de/PrivacyPolicyContactDe';
import PrivacyPolicyContactEn from './en/PrivacyPolicyContactEn';
import { useIndexUpdate } from '../common/hooks';

export function PrivacyPolicyContact(props) {
    const locale = useContext(LocaleContext);

    useIndexUpdate(props.indexUpdate, locale);

    return (
        <div>
            <div className="bottom_padding side_padding flex_col margin_to_header">
                {
                    locale.locale === "de" ?
                        <React.Suspense fallback={<SuspenseComp />}>
                            <PrivacyPolicyContactDe />
                        </React.Suspense>
                    : locale.locale === "en" ?
                        <React.Suspense fallback={<SuspenseComp />}>
                            <PrivacyPolicyContactEn />
                        </React.Suspense>
                    :
                        null
                }
            </div>

            <Footer />
        </div>
    );
}
